import GenericBody from "../Componentes/GenericBody"
import NavBar from "../Componentes/NavBar"
import BodyContent from "../Modulos/SolicitacaoPassagem/BodyContent";

const SolicitacaoPassagem = () => {

    return (
        <>
            <NavBar title="SOLICITAÇÃO DE PASSAGEM" modulo="rh" />
            <GenericBody>
                <BodyContent />
            </GenericBody>
        </>
    )

}

export default SolicitacaoPassagem;
